module.exports = __webpack_public_path__ + "img/triduum-logo.c5c10e96.svg";